import { AUTH_BROADCAST_CHANNEL_NAME } from "@constants/authCrossTab.constants";

type AuthBroadcastMessage = { type: "logout" };

export function broadcastLogoutToOtherTabs(): void {
	if (typeof BroadcastChannel === "undefined") return;
	try {
		const bc = new BroadcastChannel(AUTH_BROADCAST_CHANNEL_NAME);
		bc.postMessage({ type: "logout" } satisfies AuthBroadcastMessage);
		bc.close();
	} catch {
		// ignore unsupported / private mode
	}
}

/** Subscribe to logout from other tabs. Returns an unsubscribe function. */
export function subscribeLogoutFromOtherTabs(onLogout: () => void): () => void {
	if (typeof BroadcastChannel === "undefined") return () => {};

	try {
		const bc = new BroadcastChannel(AUTH_BROADCAST_CHANNEL_NAME);
		bc.onmessage = (event: MessageEvent<AuthBroadcastMessage>) => {
			if (event.data?.type === "logout") {
				onLogout();
			}
		};
		return () => bc.close();
	} catch {
		return () => {};
	}
}
